import React from 'react'
import "./login.scss"

export const Login = () => {
  return (
    <div>Login</div>
  )
}
